import { Injectable } from '@angular/core';
import { ComplexFormParent } from '../utils/complex-form-parent';
import { PeopleApiService, MemberApiService, FormsBillingApiService, OfficesApiService, SnackbarService, MemberPeopleApiService } from '@tangilla/tg-ng-core';
import { SurveyService } from 'src/app/core/services/survey/survey.service';
import { LoggingUtilsService } from 'src/app/core/utils/logging.utils.service';
import { SurveyUtilsService } from '../utils/survey.utils.service';

@Injectable({
  providedIn: 'root'
})
export class TransitionElectionService extends ComplexFormParent {

  override initializeOnAfterRenderPage() {
    this.surveyService.surveyModel.onAfterRenderPage.add((sender, options) => {
      const currentPage = sender.currentPage;
      switch(currentPage.name) {
        case 'Your Offices':
      }
    })
  }

  override initializeOnCurrentPageChanging(){
    this.surveyService.surveyModel.onAfterRenderPage.add((sender, options) => {
      const currentPage = sender.currentPage;
      switch(currentPage.name) {
        case 'Confirmation':
          this.buildOrderConfirmation('transition_election');
          break;
      }
    })

  }

  override initializeOnValueChanged() {
    // TODO: transition needs to be validated here as well
    this.surveyService.surveyModel.onValueChanged.add((sender, options) => {
      if(options.name === 'LicType') {
        // If it's not a Broker/Appraiser license - We need to stop the form
        const value = this.surveyService.surveyModel.getValue('LicType');
        if(value && ['Broker', 'Appraiser'].indexOf(value) === -1) {
          this.errorsService.exitForm('Error', 'Only Broker and Appraiser licenses are allowed to use this form.');
        }
      }
    })
  }

}
